import { useQuery, UseQueryOptions } from 'react-query'

import { AxiosError } from 'axios'
import ApiCall from 'services/ApiCall'

import useUrlQuery, { UseUrlQueryOptions } from 'helpers/QueryUrl/useUrlQuery'

export interface UseGetSequences {
  id: number
  name: string
  reference_model: string
  sequence_fields: any
  type: string
  editable_field: string[]
}

type UseSequencesResult = {
  data: any
  result: UseGetSequences[]
}

type TQueryFnData = UseSequencesResult
type TError = AxiosError

function useGetUserById(
  id: string,
  urlOptions?: UseUrlQueryOptions,
  options?: UseQueryOptions<TQueryFnData, TError>,
) {
  const urlQuery = useUrlQuery(urlOptions)
  const query = useQuery<TQueryFnData, TError>(
    urlQuery.transformKey(`/get-users-${id}`),
    () =>
      ApiCall.User.getById(id).then((res) => {
        return res.data
      }),
    {
      ...options,
      keepPreviousData: true,
    },
  )

  return {
    ...query,
    data: query?.data?.data,
    length: query?.data?.result?.length,
    helpers: urlQuery,
  }
}

export default useGetUserById
